<template>
  <!-- 
    name: 覃刚
    function: 营养指标查看
    date: 2021-03-15
 -->
  <div class="listContent scan-list" >
    <a-form :form="form" class="headForm">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item
            label="原料名称"
          >
            <a-input v-decorator="['keyword']" @pressEnter="getList({pageSize:pagination.pageSize,current:1})" placeholder="请输入原料名称/代码" style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col :span="6" v-if="overseasFlag==1">
          <a-form-item label="原料别名">
            <a-input @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
              v-decorator="['aliasName']" placeholder="请输入原料别名" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            label="原料类型"
          >
            <a-cascader
              v-decorator="[
                'typeArr'
              ]"
              :options="typeList"
              :load-data="loadData"
              placeholder="请选择"
              change-on-select
              @change="onChange"
            />
          </a-form-item>
        </a-col>
        
        <a-col :span="6" class="submitBtnBox">
          <a-button type="primary" class="btnMar" @click="getList({pageSize:pagination.pageSize,current:1})">
            查询
          </a-button>
          <a-button class="btnMar2" @click="resetFields">
            清空
          </a-button>
        </a-col>
      </a-row>
    </a-form>

    <a-table ref="listRef" :scroll="{y,x: 1000}" :columns="columns" :data-source="list" class="tableBox" :pagination="false">
      <template v-for="el in ['nutritionValue','nutritionAnalysisVal','baseNutritionVal']" :slot="el" slot-scope="text">
        <!-- {{Number(text) || text ? text.toFixed(2) : text}} -->
        <template v-if="text || text===0">
          <!-- {{(record.unit === 'MJ' || record.unit === 'Kcal') ? Number(text).toFixed(0) : Number(text).toFixed(4)}} -->
          {{Number(text).toFixed(4)}}
        </template>
      </template>
      
      <!-- <template slot="name" slot-scope="text,record">
        {{overseasFlag == '1' ? (record.aliasName || text) : text}}
      </template> -->
    </a-table>
  </div>
</template>
<script>
import {getRequest} from '../../Common/Utils/Utils'
export default {
  data(){
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      y: 500,
      typeList:[],
      form: this.$form.createForm(this, { name: 'rawMaterialList' }),
      selectList:[],
      confirmLoading: false,
      showAdd: false,// 是否显示新增
      showEdit: false,// 是否显示编辑
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      },
      list:[],
      pagination: {
        total:0,
        pageSize: 10000,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1
          this.pagination.pageSize = pageSize
          this.getList({current:1,pageSize})
        } //每页多少条
      },
      columns: [
        {
          title: '原料名称',
          dataIndex: 'name',
          width: 220,
          ellipsis: true,
          scopedSlots: {customRender: 'name'},
        },
        {
          title: '原料别名',
          dataIndex: 'aliasName',
          width: 220,
          ellipsis: true,
        },
        {
          title: '代码',
          dataIndex: 'code',
          width: 120,
          ellipsis: true,
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          width: 100,
          ellipsis: true,
        },
        {
          title: '数值',
          dataIndex: 'nutritionValue',
          scopedSlots: { customRender: 'nutritionValue' },
          width: 120,
          ellipsis: true,
          sorter: (a, b) => a.nutritionValue - b.nutritionValue,
        },
        {
          title: '营养分析',
          dataIndex: 'nutritionAnalysisVal',
          scopedSlots: { customRender: 'nutritionAnalysisVal' },
          width: 120,
          ellipsis: true,
          sorter: (a, b) => a.nutritionAnalysisVal - b.nutritionAnalysisVal,
        },
        {
          title: '基础工厂',
          dataIndex: 'baseNutritionVal',
          scopedSlots: { customRender: 'baseNutritionVal' },
          width: 120,
          ellipsis: true,
          sorter: (a, b) => a.baseNutritionVal - b.baseNutritionVal,
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: 100,
          ellipsis: true,
        }
      ],
      rowSelection:{
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.selectList = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          console.log(record, selected, selectedRows);
          this.selectList = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log(selected, selectedRows, changeRows);
          this.selectList = selectedRows
        }
      }
    }
  },
  mounted(){
    this.getList()
    this.getTypeList()
    this.y = this.$refs.listRef.$el.offsetHeight - 70
  },
  methods:{
    getTypeList(parentId=0,record,type){
      // this.$http.get(`/nhf-core-data/basictype/listByParentId?category=raw&parentId=${parentId}`)
      // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail')
      let factoryDetail = obj ? JSON.parse(obj) : {}
      let { deptId } = factoryDetail
      this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit?category=raw&parentId=${parentId}&deptId=${deptId}`)
      .then(res => {
        let {success,data=[]} = res;
        if(success){
          data && data.map(el => {
            el.value = el.id
            el.label = el.name
            el.isLeaf = !el.hasChildren
            // el.isLeaf = false
            return el
          })
          if(record){
            // data = [
            //   {name: '测试1',id: '测试1',value: '测试1',label: '测试1',isLeaf: '测试1'}
            // ]
            if(data.length){
              record.children = data
            }else {
              record.isLeaf = true
            }
            if(!type){
              this.typeList = [...this.typeList]
            }else{
              this.list = [...this.list]
            }
          }else{
            this.typeList = data
          }
          // this.typeList = data
          // return data
        }else{
          this.typeList = []
        }
      })
    },
    resetFields(){
      this.form.resetFields()
    },
    getList(pagination){
      this.selectList = []
      let {current=1,pageSize=10000} = pagination || {}
      let factoryId = window.localStorage.getItem('factoryId')
      let nutritionId = getRequest('id')
      this.form.validateFields((err, data) => {
        let {typeArr=[],...newdata} = data
        let params = {
          ...newdata,
          factoryId,
          current,
          size:pageSize,
          nutritionId,
          typeId: typeArr.length ? typeArr[typeArr.length - 1] : undefined
        }
        this.$http.get('/nhf-app/nutritionMage/nutritionRawPage',{params}).then(res => {
          let {success,data} = res;
          if(success){
            let {records,current=1,total=0} = data;
            this.pagination.current = current
            this.pagination.total = total
            records && records.map(el => {
              el.edit = false
            })
            this.list = records || []
            this.oldList = JSON.parse(JSON.stringify(records))
          }else{
            this.$message.error('查询失败')
          }
        })
      })
    },
    editRow(record,val){
      // 编辑行
      record.edit = val
    },
    deleteData(){
      if(this.selectList.length){
        this.$confirm({
          title: '提示',
          content: '确认将选中的原料删除吗？',
          cancelText:'取消',
          okText:'确定',
          onOk() {
            console.log('删除成功。')
          },
          onCancel() {
            console.log('取消删除。')
          },
        });
      }else{
        this.$message.warning('请选中要删除的数据')
      }
      
    },
    addSubmit(){
      // 新增提交
      // console.log()
      this.$refs['add'].form.validateFields((err, values) => {
        console.log(values)
      })
      this.showAddFunc()
    },
    showAddFunc(){
      // 新增显示或关闭
      this.showAdd = !this.showAdd
    },
    editSubmit(){
      // 编辑提交
      this.$refs['edit'].form.validateFields((err, values) => {
        console.log(values)
      })
      this.showEditFunc()
    },
    showEditFunc(type){
      // 编辑显示或关闭
      if(type === 'edtiBtn'){
        if(this.selectList.length > 1){
          this.$message.warning('编辑只能选中一条数据')
        }else if(this.selectList.length === 0){
          this.$message.warning('请选中需要编辑的数据')
        }else{
          this.showEdit = !this.showEdit
        }
      }else{
        this.showEdit = !this.showEdit
      }
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        // this.$emit('getTypeList',{targetOption,id:targetOption.id})
        this.getTypeList(targetOption.id,targetOption) || []
        // this.typeList = [...this.typeList];
      }, 0);
    },
    onChange(value) {
      console.log(value);
    },
  }
}
</script>

<style lang="scss" scoped>
.listContent{
  .tableBox{
    height: calc(100% - 81px);
  }
}
</style>